export const formatSingaporePhone = (phone) => {
  if (!phone) return null

  // 1. Chỉ giữ lại chữ số
  let clean = phone.replace(/[^0-9]/g, '')

  // 2. Bỏ số 0 ở đầu nếu người dùng quen tay gõ 0
  if (clean.startsWith('0')) {
    clean = clean.slice(1)
  }

  // 3. Nếu người dùng nhập 8 chữ số (đầu 8 hoặc 9) -> tự động thêm mã '65'
  if (/^[89]\d{7}$/.test(clean)) {
    return `65${clean}`
  }

  // 4. Nếu người dùng đã có sẵn '65' và theo sau là 8 chữ số (đầu 8 hoặc 9) -> hợp lệ
  if (/^65[89]\d{7}$/.test(clean)) {
    return clean
  }

  // Không đúng định dạng số di động Singapore
  return null
}
